export const EVENT_OPEN_SEARCH_DATES = 'open_search_dates';
export const EVENT_OPEN_SEARCH_RV_PROFILE = 'open_search_rv_profile';

export const triggerOpenSearchHeaderDates = () => {
  document.dispatchEvent(new CustomEvent(EVENT_OPEN_SEARCH_DATES));
};

export const triggerOpenSearchHeaderRVProfile = () => {
  document.dispatchEvent(new CustomEvent(EVENT_OPEN_SEARCH_RV_PROFILE));
};
